import * as React from 'react'
import { ServiceNoResultsCard } from '../../ServiceNoResultsCard'
import { ServiceProductsCard } from '../../styled'
import { ServiceProductContents } from '../../ServiceProductContents'
import Divider from '@mui/material/Divider'
import { Props as ServiceListProps } from '../ServiceList'

type Props = Pick<
  ServiceListProps,
  | 'deleteWarningMessage'
  | 'disableEdit'
  | 'entityType'
  | 'localMode'
  | 'minimumServicesCount'
  | 'onEditClick'
  | 'serviceFrequencies'
  | 'readOnly'
  | 'services'
  | 'totalServicesCount'
>

export function NewServiceContents(props: Props) {
  const { minimumServicesCount, services, totalServicesCount } = props
  return (
    <ServiceProductsCard elevation={0}>
      {services.length > 0 ? (
        services.map((s, i) => (
          <React.Fragment key={s.id}>
            <ServiceProductContents
              key={s.id}
              service={s}
              index={i}
              {...props}
              frequency={props.serviceFrequencies.find(
                (x) => x.id == s.frequencyId,
              )}
              disableDelete={
                !!totalServicesCount &&
                !!minimumServicesCount &&
                totalServicesCount <= minimumServicesCount
              }
              deleteWarningMessage={props.deleteWarningMessage ?? ''}
              readOnly={props.readOnly}
            />
            {i < services.length - 1 && <Divider />}
          </React.Fragment>
        ))
      ) : (
        <ServiceNoResultsCard label="No Services or Products Added" />
      )}
    </ServiceProductsCard>
  )
}
